/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

const FieldContextReducer = (state, action) => {

    switch (action?.type) {
        case "SET_ZONE_FIELD_ITEM": {
            const { name, value } = action;
            return {
                ...state,
                [name]: value,
            };
        }
        default: {
            // Logger.debug('error');
            return {
                ...state,
            };
        }
    }
};

export { FieldContextReducer };
